export default {
  path: 'notes-tasks',
  name: 'publisher/notes-tasks',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-notes-tasks" */ './NotesTasks')
}
